export const EN_ACCEPT_LANGUAGE:string="en";
export const LA_ACCEPT_LANGUAGE:string="lo";
